<ng-container *ngIf="this.isLink">
  <a class="section" [class.active]="markedAsActive" (click)="navigateToUrl()">{{text}}</a>
</ng-container>
<ng-container *ngIf="!this.isLink">
  <div class="section" [class.active]="markedAsActive">{{text}}</div>
</ng-container>
